"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";

export function Layout204() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2 lg:gap-x-20">
          <div className="order-2 md:order-1">
            <img
              src="/images/layouts/integration-modes.png"
              className="w-full object-cover"
              alt="Relume placeholder image"
            />
          </div>
          <div className="order-1 md:order-2">
            <p className="mb-3 font-semibold md:mb-4">Flexibility</p>
            <h2 className="mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
              Full integration or read-only, your choice
            </h2>
            <p className="mb-5 md:mb-6 md:text-md">
              Use Full Integration when you want real automation and two-way
              sync. Use Render Only when you want safe, read-only dashboards
              with zero risk to your source data.
            </p>
            <div className="flex flex-wrap items-center gap-x-8 gap-y-6 py-2">
              <img
                src="/images/layouts/integration-modes.png"
                alt="Webflow logo 1"
                className="max-h-12"
              />
              <img
                src="/images/layouts/ai-insights.png"
                alt="Relume logo 1"
                className="max-h-12"
              />
              <img
                src="/images/layouts/integration-modes.png"
                alt="Webflow logo 2"
                className="max-h-12"
              />
              <img
                src="/images/layouts/ai-insights.png"
                alt="Relume logo 2"
                className="max-h-12"
              />
            </div>
            <div className="mt-6 flex flex-wrap gap-4 md:mt-8">
              <Button title="Explore" variant="secondary">
                Explore
              </Button>
              <Button
                title="Arrow"
                variant="link"
                size="link"
                iconRight={<RxChevronRight />}
              >
                Arrow
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
